/* unplugin-vue-components disabled */import { render } from "./templatePop_1.vue?vue&type=template&id=9ab4dd30&scoped=true"
import script from "./templatePop_1.vue?vue&type=script&lang=js"
export * from "./templatePop_1.vue?vue&type=script&lang=js"

import "./templatePop_1.vue?vue&type=style&index=0&id=9ab4dd30&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab4dd30"]])

export default __exports__